import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext } from '../../../../../../../../hooks'
import { AccountFromTemplateFormSchema } from '../../types'
import { RequiredFieldLabel } from '../RequiredFieldLabel'

export const AccountNameFormItem = (): ReactElement => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<AccountFromTemplateFormSchema>()

  return (
    <FormItem
      label={<RequiredFieldLabel>{t('coa.account_from_base_form.edit_account_name')}</RequiredFieldLabel>}
      name="name"
      render={({ field }) => (
        <Input {...field} placeholder={t('coa.account_from_base_form.account_name.placeholder')} size="sm" />
      )}
    />
  )
}
